import { Dispatch } from 'redux'
import { MagentoClient } from 'lib/core/services/magento'
import { fetchWishlist } from 'lib/core/data/customer/wishlist'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { findItemBySku } from 'lib/core/data/customer/wishlist/selectors'
import { useCoreContext } from '../useCoreContext'
import { Ga4Events } from '../../../gtm/index'
import { useProductBySku } from '../../../modules/catalog/index'

const ACTION_ADD = 'addProductToWishlist'
const ACTION_REMOVE = 'removeWishlistItem'

type Action = 'addProductToWishlist' | 'removeWishlistItem'

type UpdateWishlist = (action: Action, args: {
  sku: string
  isLoading: boolean
  setIsLoading: (x: boolean) => void
  dispatch: Dispatch<any>
  magentoClient?: MagentoClient
  onError: any
}) => void

const updateWishlist: UpdateWishlist = async (action: Action, {
  sku,
  isLoading,
  setIsLoading,
  dispatch,
  magentoClient,
  onError
}) => {
  if (isLoading) {
    return
  }

  setIsLoading(true)
  try {
    await magentoClient?.customer[action]({ sku })
    await dispatch(fetchWishlist())
  } catch (e) {
    onError?.(e)
  }
  setIsLoading(false)
}

export const useWishlist = (sku: string) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const wishlistItem = useSelector(findItemBySku(sku))
  const { product } = useProductBySku({ sku })
  const isAddedToWishlist = !!wishlistItem
  const { magentoClient } = useCoreContext()
  const { onError } = useCoreContext()

  const handleAddToWishlist = () => {
    updateWishlist(ACTION_ADD, {
      sku,
      isLoading,
      setIsLoading,
      dispatch,
      magentoClient,
      onError
    })
    if (product) {
      Ga4Events.addToWishList({ product })
    }
  }

  const handleRemoveFromWishlist = () => {
    updateWishlist(ACTION_REMOVE, {
      sku,
      isLoading,
      setIsLoading,
      dispatch,
      magentoClient,
      onError
    })
  }

  return {
    handleRemoveFromWishlist,
    handleAddToWishlist,
    isAddedToWishlist,
    isLoading
  }
}
